import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  addAccountUser,
  getAccountUserList,
  deleteAccountUser,
  updateAccountUser,
  activateAccountUser,
  deActivateAccountUser
}
  from "api/userV2.api";
import { notificationController } from "controllers/notificationController";
import { IEditDeleteId, IUserAccountData, IUserData, UserRequest } from "domain/User";

export interface UserSlice {
  erpUserAccountList: IUserData[] | null;
  erpClientUserList: IUserData[] | null;
}

const initialState: UserSlice = {
  erpUserAccountList: null,
  erpClientUserList: null,
};

export const doGetAccountUser = createAsyncThunk("erpUser/doGetAccountUser", async () =>
    getAccountUserList().then((res: IUserData[]) => {
    return res;
  })
);

export const doAddAccountUser = createAsyncThunk(
  "erpUser/doAddAccountUser",
  async (professionalPayload: UserRequest, { dispatch }) =>
    addAccountUser(professionalPayload).then((res) => {
      dispatch(doGetAccountUser());
      return res;
    })
);
export const doUpdateAccountUser = createAsyncThunk(
  "erpUser/doUpdateAccountUser",
  async (professionalPayload: IUserAccountData, { dispatch }) =>
    updateAccountUser(professionalPayload.id, professionalPayload).then((res) => {
      dispatch(doGetAccountUser());
      return res;
    })
);

export const doDeleteAccountUser = createAsyncThunk(
  "erpUser/doDeleteUser",
  async (roleId: IEditDeleteId, { dispatch }) => {
    deleteAccountUser(roleId).then(
      (res) => {
        notificationController.error({
          message:  "User deleted successfully.",
        });
        dispatch(doGetAccountUser());
        return res;
      },
      (error) => {
        notificationController.error({
          message: error.toString(),
        });
      }
    );
  }
);

export const doDeActivateAccountUser = createAsyncThunk(
  "erpUser/doDeActivateUser",
  async (userId: IEditDeleteId, { dispatch }) => {
    deActivateAccountUser(userId).then(
      (res) => {
        notificationController.error({
          message: "User deactivated successfully.",
        });
        dispatch(doGetAccountUser());
        return res;
      },
      (error) => {
        notificationController.error({
          message: error.toString(),
        });
      }
    );
  }
);

export const doActivateAccountUser = createAsyncThunk(
  "erpUser/doActivateUser",
  async (userId: IEditDeleteId, { dispatch }) => {
    activateAccountUser(userId).then(
      (res) => {
        notificationController.error({
          message: "User activated successfully.",
        });
        dispatch(doGetAccountUser());
        return res;
      },
      (error) => {
        notificationController.error({
          message: error.toString(),
        });
      }
    );
  }
);

const erpUserAccountSlice = createSlice({
  name: "erpUser",
  initialState,
  reducers: {
    clearUserList: (state) => {
      state.erpUserAccountList = null;
    },
    clearClientUserList: (state) => {
      state.erpClientUserList = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(doGetAccountUser.fulfilled, (state, action) => {
      state.erpUserAccountList = action.payload;
    });
  },
});

export const {
  clearUserList,
  clearClientUserList,
} = erpUserAccountSlice.actions;

export default erpUserAccountSlice.reducer;
